import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { finalize } from "rxjs/operators";
import { isNullOrUndefined, ToastService } from "../core";
import {
  AdditionalInfoObject,
  AmmendExitActivityFilter,
  ConfigurationApi,
  ExitRequestActivity,
  IImmigrationDocumentVisaMappingDTO,
  ImmDocumentVisaMappingFilter,
  ImmigrationDocumentVisaMappingDTO,
  LookupApi,
} from "../core/api.gen";
import { CommonService } from "../core/common.service";
import { DialogService } from "../core/dialog.service";
import { LoaderService } from "../core/loader.service";
import { LookupTypeKeys } from "../shared/lookup-type-keys";
import { nullSafe } from "../utils";

@Component({
  selector: "eos-imm-document-visamapping",
  templateUrl: "./imm-document-visamapping.component.html",
  styleUrls: ["./imm-document-visamapping.component.css"],
})
export class ImmDocumentVisamappingComponent implements OnInit {
  activities: ImmigrationDocumentVisaMappingDTO[] = [];
  activity: any;
  isAscending: boolean = false;
  activityFilter = new UntypedFormGroup({
    country: new UntypedFormControl(null, [Validators.required]),
    visaType: new UntypedFormControl(null),
    isRequestor: new UntypedFormControl(null),
    isApprover: new UntypedFormControl(null),
  });
  countries = [];
  visaTypes = [];
  documentTypes = [];
  documentNames = [];
  visaTypesInfo = [];

  nationalityType = [];
  officeLocation = [];
  exitTypes = [];
  exitSubType = [];
  rank = [];
  exitTypeId: number = 0;
  activityInfo: ImmigrationDocumentVisaMappingDTO;
  exitSubTypeValue = [];

  activityTypes = [
    {
      id: 100,
      displayText: "Email",
      disabled: true,
    },
    {
      id: 101,
      displayText: "Profile update",
    },
    {
      id: 102,
      displayText: "External",
      disabled: true,
    },
    {
      id: 103,
      displayText: "Request",
      disabled: true,
    },
  ];
  constructor(
    private configurationService: ConfigurationApi,
    private common: CommonService,
    private lookupApi: LookupApi,
    private loader: LoaderService,
    private dialogService: DialogService,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.loadSupportingData()
      .pipe(finalize(() => this.loader.clear()))
      .subscribe((p) => {
        this.countries = p.countries.filter(i => [1048, 1047, 1052, 1049, 1050, 1051, 1055, 1053, 13410].includes(i.id));
        this.visaTypes = p.visaTypes;
        this.documentTypes = p.documentTypes.filter(x => x.filterKeyId == 1);
        this.documentNames = p.documentNames.filter(x => x.filterKeyId == 1);
      });
    this.valuechangeSubscription();
  }

  loadSupportingData() {
    this.loader.show();
    return forkJoin({
      countries: this.lookupApi.getLookupFieldsByTypes([
        LookupTypeKeys.OFFICE_LOCATION_COUNTRY,
      ]),
      visaTypes: this.lookupApi.getLookupFieldsByTypes([
        LookupTypeKeys.VISA_TYPE,
      ]),
      documentTypes: this.lookupApi.getLookupFieldsByTypes([
        LookupTypeKeys.DOCUMENT_TYPES,
      ]),
      documentNames: this.lookupApi.getLookupFieldsByTypes([
        LookupTypeKeys.DOCUMENT_NAMES,
      ]),
    });
  }
  createActivity() {
    this.activityInfo = undefined;
    let countryId = !isNullOrUndefined(this.activityFilter.controls.country.value) ? this.activityFilter.controls.country.value : 0;
    let visaTypeId = !isNullOrUndefined(this.activityFilter.controls.visaType.value) ? this.activityFilter.controls.visaType.value : 0;
    this.dialogService
      .showImmDocumentVisamappingEdit(
        this.activityInfo,
        this.countries,
        this.visaTypes,
        this.documentTypes,
        this.documentNames,
        false,
        countryId,
        visaTypeId
      )
      .result.then((result) => {
        if (result === "success") {
          this.getImmMappings();
        }
      });
  }
  onSubmit() {
    this.getImmMappings();
  }
  getImmMappings() {
    if (this.activityFilter.valid) {
      this.loader.show();
      const filter = this.getFormData();
      this.configurationService
        .getImmDocumentVisaMappings(filter)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe((resp) => {
          this.activities = resp;
        });
    }
  }

  onCountryChange($event) {
    this.countryValueChange();
  }
  countryValueChange() {
    const a = this.activityFilter.controls.country.value;
    if (a != null && a !== undefined) {
      this.activityFilter.controls.visaType.reset();
      this.visaTypesInfo = this.visaTypes.filter((i) =>
        [a].includes(i.parentFieldId)
      );
    }
  }

  editActivity(id: number) {
    this.configurationService.getImmDocVisaMappingsById(id).subscribe((res) => {
      if (res) {
        console.log('Edit call ',res);
        this.activityInfo = res;
        this.dialogService
          .showImmDocumentVisamappingEdit(
            this.activityInfo,
            this.countries,
            this.visaTypes,
            this.documentTypes,
            this.documentNames,
            true,
            0,
            0
          )
          .result.then((result) => {
            if (result === "success") {
              this.getImmMappings();
            }
          });
      }
    });
  }
  clearForm() {
    this.activityFilter.reset();
    this.activity = [];
    this.activities = [];
  }

  getFormData() {
    const form = this.activityFilter.getRawValue();
    const filter = new ImmDocumentVisaMappingFilter({
      officeLocation: form.country,
      visaType: form.visaType,
      isRequestor: form.isRequestor,
      isApprover: form.isApprover,
    });
    console.log("Filters ", filter);
    return filter;
  }

  valuechangeSubscription() {
    this.activityFilter.get("exitType").valueChanges.subscribe((x) => {
      if (x) {
        this.exitTypeId = x.id;
        this.lookupApi
          .getLookupFieldsByTypes([LookupTypeKeys.EXIT_SUBTYPES])
          .subscribe((resp) => {
            //console.log(this.exitTypeId)
          });
      }
      this.restControls();
    });
  }
  restControls() {
    this.activityFilter.get("exitSubType").reset();
    this.activityFilter.get("officeLocation").reset();
    this.activityFilter.get("nationalityType").reset();
  }

  onChange($event) {
    if ($event) {
      this.activities = this.activity.filter((x) => x.isActive == true);
    } else {
      this.activities = this.activity.filter(
        (x) => x.isActive == true || x.isActive == false
      );
    }
  }

  sort() {
    // if (!this.isAscending) {
    //   this.activities = this.activities
    //     .filter((act) => act.order !== 0)
    //     .sort((a, b) => (a.order < b.order ? -1 : 1))
    //     .concat(this.activities.filter((act) => act.order === 0));
    //   this.isAscending = true;
    // } else {
    //   this.activities = this.activities
    //     .filter((act) => act.order !== 0)
    //     .sort((a, b) => (a.order > b.order ? -1 : 1))
    //     .concat(this.activities.filter((act) => act.order === 0));
    //   this.isAscending = false;
    // }
  }
  updateOrder(act) {
    const exitActivity = this.getExitActivity(act);
    if (exitActivity.isActive && exitActivity.order <= 0) {
      this.toast.warning(
        "Order should be greater than zero for an active activity"
      );
    } else {
      this.configurationService
        .saveExitActivities(exitActivity)
        .pipe(
          finalize(() => {
            this.loader.clear();
          })
        )
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.statusCode == 400) {
                this.toast.warning("Activity with same order already exist");
              } else {
                this.toast.success("Order successfully updated");
              }
            }
          },
          (err) => {
            this.toast.error("An error occurred. Please try again.");
          }
        );
    }
  }

  getExitActivity(rawValues) {
    const internalAct = new ExitRequestActivity({
      activityType: rawValues.activityType,
      order: rawValues.order,
      header: rawValues.header,
      description: rawValues.description,
      exitTypeId: rawValues.exitTypeId,
      id: rawValues.id,
      isActive: rawValues.isActive,
      additionalInfoObj: !isNullOrUndefined(rawValues.additionalInfo)
        ? this.checkIfAdditionalInfoNull(JSON.parse(rawValues.additionalInfo))
        : null,
    });
    return internalAct;
  }

  checkIfAdditionalInfoNull(rawValues) {
    const obj = new AdditionalInfoObject({
      exitSubTypes: rawValues.ExitSubTypes,
      officeLocation: rawValues.OfficeLocation,
      nationalityType: rawValues.NationalityType,
      isPartner: rawValues.IsPartner === 1 ? 1 : null,
      rank: rawValues.Rank,
    });
    Object.keys(obj).forEach((key) => {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        nullSafe(() => obj[key].length === 0)
      ) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every((x) => x === null);
  }
}
